import React, { Component } from 'react'
import './MyPage.css'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import moment from 'moment'
import Axios from '../../../auth/axios'
import { Button } from 'reactstrap'
// import ReactPlacesComponent from "../../CommonComponents/ReactPlacesComponent/ReactPlacesComponent";

class MyComponent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      // personalInformation
      profilePic: '',
      firstName: '',
      lastName: '',
      contact: '',
      emailId: '',
      dateOfBirth: moment().format('YYYY-MM-DD'),
      gender: '',
      permanentAddress: '',
      locality: '',
      pincode: '',
      panNumber: '',
      panDocs: '',
      adharNumber: '',
      aadharDocs: '',
      errorCount: '',
      isLoading: false,

      // qualificationInformation
      // ug Details
      ugDegreeData: [],
      ugDegree: '',
      typeOfProgram: '',
      areaOfSpecialisation: '',
      college: '',
      yearOfCompletion: moment().format('YYYY-MM-DD'),
      ugDegreeDocs: [],
      otherDegreeName: '',
      //pg details
      pgTypeOfProgram: '',
      otherPgDegreeName: '',
      pgDegree: '',
      pgAreaOfSpecialisation: '',
      pgCollege: '',
      pgYearOfCompletion: moment().format('YYYY-MM-DD'),
      pgDegreeData: [],
      pgDegreeDocs: [],

      //professional course
      professionalCourse: [],
      professionalCourseName: '',
      professionalYearOfCompletion: moment().format('YYYY-MM-DD'),
      professionalCourseAffiliatedBoard: '',
      professionalCourseLicenseNumber: '',
      professionalCourseValidity: '',
      professionalCourseDocs: [],

      // business information
      //tax details
      typeOfBusiness: '',
      gstStatus: '',
      tanStatus: '',
      tanNumber: '',
      stateOfSupply: '',
      taxCode: '',

      //Details of Business
      legalNameOfBusiness: '',
      businessPanNumber: '',
      registeredAddressFirm: '',
      imageGallery: '',

      //GSTIN Details
      gstRegistrationType: '',
      gstinNumber: '',
      gstinDocs: '',

      //Bank Account Details
      bankAccountType: '',
      accountHolderName: '',
      accountNumber: '',
      ifscCode: '',
      bankAddress: '',
      cancelledChequeDocs: '',

      //for doc names
      imageGalleryNames: [],
      gstInDocsNames: []
    }

    // personalInformation
    this.changeHandler = this.changeHandler.bind(this)
    this.submitHandler = this.submitHandler.bind(this)
    this.adharFileChangeHandler = this.adharFileChangeHandler.bind(this)
    this.panFileChangeHandler = this.panFileChangeHandler.bind(this)
    this.profilePicChangeHandler = this.profilePicChangeHandler.bind(this)

    // qualificationInformation
    this.ugDegreeHandler = this.ugDegreeHandler.bind(this)
    this.ugDocs = this.ugDocs.bind(this)
    this.pgDegreeHandler = this.pgDegreeHandler.bind(this)
    this.pgDocs = this.pgDocs.bind(this)
    this.professionalCourseHandler = this.professionalCourseHandler.bind(this)
    this.professionalCourseDocsHandler = this.professionalCourseDocsHandler.bind(
      this
    )

    // businesInformation
    this.businessInformationDetails = this.businessInformationDetails.bind(this)
    this.imageGalleryPic = this.imageGalleryPic.bind(this)
    this.cancelledCheque = this.cancelledCheque.bind(this)
    this.gstDocs = this.gstDocs.bind(this)
  }

  // for form text fields
  changeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
    console.log(e.target.name, ' => ', e.target.value)
  }

  // for UG Docs
  ugDocs = e => {
    if (e.target.files.length > 2) {
      //show error toast
      toast.error(`You can't upload more then 2 files`, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
      e.target.value = null
      return null
    }

    if (
      this.maxSelectedFilesForAadhar(e) &&
      this.checkFileSizeForAadharDocs(e)
    ) {
      this.setState({ ugDegreeDocs: e.target.files })
    }
  }

  // for ProfilePic
  profilePicChangeHandler = profileImgEvent => {
    console.log('----calling-------')
    if (profileImgEvent.target.files.length > 1) {
      toast.error(`You can't upload more then 1 file`, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
      profileImgEvent.target.value = null
      return null
    }

    if (this.checkFileSizeForPan(profileImgEvent)) {
      console.log('profileImg => ', profileImgEvent.target.files[0])
      this.setState({ profilePic: profileImgEvent.target.files[0] })
    }
  }

  // for PG Docs
  pgDocs = e => {
    console.log('pg File loaded')
    this.setState({
      pgDegreeDocs: e.target.files
    })
  }

  // for AdharFileDocuments
  adharFileChangeHandler = e => {
    //check max 2 files are uploaded
    if (e.target.files.length > 2) {
      //show error toast
      toast.error(`You can't upload more then 2 files`, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
      e.target.value = null
      return null
    }

    if (
      this.maxSelectedFilesForAadhar(e) &&
      this.checkFileSizeForAadharDocs(e)
    ) {
      this.setState({ aadharDocs: e.target.files })
    }
  }

  checkFileSizeForAadharDocs = event => {
    let files = event.target.files
    let size = 400000
    let err = ''
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + 'is too large, please pick a smaller file\n'
      }
    }
    if (err !== '') {
      event.target.value = null
      console.log(err)
      //show error toast
      toast.error(`File size exceeds permissible limit`, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
      return false
    }

    return true
  }

  maxSelectedFilesForAadhar = event => {
    let files = event.target.files // create file object
    if (files.length > 3) {
      const msg = 'Only 2 images can be uploaded at a time'
      event.target.value = null // discard selected file
      console.log(msg)
      return false
    }
    return true
  }

  // for PanFileDocuments
  panFileChangeHandler = e => {
    if (e.target.files.length > 1) {
      toast.error(`You can't upload more than 1 file`, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        cloesOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
      e.target.value = null
      return null
    }

    if (this.maxSelectedFilesForPan(e) && this.checkFileSizeForPan(e)) {
      let file = e.target.files
      this.setState({ panDocs: file })
    }
  }

  maxSelectedFilesForPan = e => {
    let files = e.target.files
    if (files.length > 2) {
      const msg = 'Only 1 image can be uploaded at a time'
      e.target.value = null
      console.log(msg)
      return false
    }
    return true
  }

  checkFileSizeForPan = e => {
    let files = e.target.files
    let size = 400000
    let err = ''
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + 'is too large, please pick a smaller file\n'
      }
    }
    if (err !== '') {
      e.target.value = null
      console.log(err)
      // show error Message in toast
      toast.error(`File Size exceeds limit`, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
      return false
    }
    return true
  }

  // for Submit the form of personalInformation
  submitHandler = async e => {
    const data = new FormData()

    data.append('firstName', this.state.firstName)
    data.append('lastName', this.state.lastName)
    data.append('mobile', this.state.contact)
    data.append('email', this.state.emailId)
    data.append('dob', this.state.dateOfBirth)
    data.append('gender', this.state.gender)
    data.append('permanentAddress', this.state.permanentAddress)
    data.append('locality', this.state.locality)
    data.append('pincode', this.state.pincode)
    data.append('panNumber', this.state.panNumber)

    data.append('aadharNumber', this.state.adharNumber)
    // data.append("adharFile", this.state.adharFile);

    for (var x = 0; x < this.state.aadharDocs.length; x++) {
      data.append('aadharDocs', this.state.aadharDocs[x])
    }

    for (var y = 0; y < this.state.panDocs.length; y++) {
      data.append('panDocs', this.state.panDocs[y])
    }

    data.append('profilePic', this.state.profilePic)

    // const config = {
    //   headers: { 'content-type': 'multipart/form-data' }
    // }

    // console.log('Data => ', data);

    // const response = await Axios.post('/vendor-personal', data)
    Axios.post('/vendor-personal', data)
      .then(function (response) {
        console.log(response)
      })
      .catch(function (error) {
        console.log(error)
      })
    // console.log(response)
    // toast.success("🦄 Wow so easy!", {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    // });
    e.preventDefault()

    // console.log(JSON.stringify(this.state));
    // this.setState({
    //   errorCount: 0,
    // });
  }

  // submit UG Details with other professional and pg Degree Details
  ugDegreeHandler = async e => {
    const { pgDegreeData, professionalCourse } = this.state
    const ugData = new FormData()

    ugData.append('ugDegree', this.state.ugDegree)
    ugData.append('typeOfProgram', this.state.typeOfProgram)
    ugData.append('areaOfSpecialisation', this.state.areaOfSpecialisation)
    ugData.append('college', this.state.college)
    ugData.append('yearOfCompletion', this.state.yearOfCompletion)
    // ugData.append('ugDegreeDocs', this.state.ugDegreeDocs);
    ugData.append('OtherDegreeName', this.state.otherDegreeName)

    for (var x = 0; x < this.state.ugDegreeDocs.length; x++) {
      ugData.append('ugDegreeDocs', this.state.ugDegreeDocs[x])
    }

    ugData.append('pgDegree', JSON.stringify(pgDegreeData))
    ugData.append('professionalCourse', JSON.stringify(professionalCourse))

    this.state.ugDegreeData.push(ugData)

    console.log('Data => ', ugData)

    Axios.post('vendoreducational', ugData)
      .then(function (response) {
        console.log('Response => ', response)
      })
      .catch(function (error) {
        console.log('Error => ', error)
      })
    // console.log('ugDetails Response => ', ugDetails)
    e.preventDefault()
  }

  // submit pg Degree
  pgDegreeHandler = async e => {
    const {
      pgTypeOfProgram,
      otherPgDegreeName,
      pgDegree,
      pgAreaOfSpecialisation,
      pgCollege,
      pgYearOfCompletion,
      pgDegreeDocs
    } = this.state

    console.log('length of pgDegree Array => ', this.state.pgDegreeData.length)
    if (this.state.pgDegreeData.length >= 3) {
      console.log('You cannot add more than 3 pg Degrees!')
      return
    }

    const pgDegreeData = [...this.state.pgDegreeData]
    pgDegreeData.push({
      pgTypeOfProgram,
      otherPgDegreeName,
      pgDegree,
      pgAreaOfSpecialisation,
      pgCollege,
      pgYearOfCompletion,
      pgDegreeDocs
    })

    this.setState({ pgDegreeData })

    console.log('Values => ', this.state.pgDegreeData)

    e.preventDefault()
    e.stopPropagation()
  }

  // delete pgDegree
  handlePgDegreeDelete = givenIndex => {
    console.log('Remove Degree from => ', givenIndex)
    let pgDegreeData = [...this.state.pgDegreeData]
    pgDegreeData = pgDegreeData.filter((element, index) => index !== givenIndex)
    console.log('New pgDegreeData => ', pgDegreeData)
    this.setState({ pgDegreeData })
  }

  // delete professionalCourse
  handleProfessionalCourseDeletion = indexNumber => {
    console.log('Remove PGCourse from => ', indexNumber)
    let professionalCourse = [...this.state.professionalCourse]
    professionalCourse = professionalCourse.filter(
      (element, index) => index !== indexNumber
    )
    console.log('New ProfessionalCourseArray => ', professionalCourse)
    this.setState({ professionalCourse })
  }

  // submit professionalCourse
  professionalCourseHandler = async ev => {
    const {
      professionalCourseName,
      professionalYearOfCompletion,
      professionalCourseAffiliatedBoard,
      professionalCourseLicenseNumber,
      professionalCourseValidity,
      professionalCourseDocs
    } = this.state

    console.log(
      'Length of professionalCourse Array => ',
      this.state.professionalCourse.length
    )
    if (this.state.professionalCourse.length >= 5) {
      console.log('You cannot ad more than 5 ProfessionalCourses !')
      return
    }

    const professionalCourse = [...this.state.professionalCourse]
    professionalCourse.push({
      professionalCourseName,
      professionalYearOfCompletion,
      professionalCourseAffiliatedBoard,
      professionalCourseLicenseNumber,
      professionalCourseValidity,
      professionalCourseDocs
    })

    this.setState({ professionalCourse })
    console.log('values => ', this.state.professionalCourse)
    ev.preventDefault()
    ev.stopPropagation()
  }

  // submit ProfessionalCourse Documents
  professionalCourseDocsHandler = ev => {
    console.log('pg File loaded')
    this.setState({
      professionalCourseDocs: ev.target.files
    })
  }

  // submit business information
  businessInformationDetails = async event => {
    const {
      typeOfBusiness,
      gstStatus,
      tanStatus,
      tanNumber,
      stateOfSupply,
      taxCode,
      legalNameOfBusiness,
      businessPanNumber,
      registeredAddressFirm,
      gstRegistrationType,
      imageGalleryNames,
      gstinNumber,
      gstinDocs,
      bankAccountType,
      accountHolderName,
      accountNumber,
      ifscCode,
      bankAddress,
      cancelledChequeDocs
    } = this.state
    const businessData = new FormData()
    // tax Details
    businessData.append('typeOfBusiness', typeOfBusiness)
    businessData.append('gstStatus', gstStatus)
    businessData.append('tanStatus', tanStatus)
    businessData.append('tanNumber', tanNumber)
    businessData.append('stateOfSupply', stateOfSupply)
    businessData.append('taxCode', taxCode)

    // Business Details
    businessData.append('legalNameOfBusiness', legalNameOfBusiness)
    businessData.append('businessPanNumber', businessPanNumber)
    businessData.append('registeredAddressFirm', registeredAddressFirm)
    for (var y = 0; y < imageGalleryNames.length; y++) {
      businessData.append('imageGallery', imageGalleryNames[y])
    }

    // GSTIN Details
    if (gstStatus === '1') {
      businessData.append('gstRegistrationType', gstRegistrationType)
      businessData.append('gstinNumber', gstinNumber)
      for (var x = 0; x < gstinDocs.length; x++) {
        businessData.append('gstinDocs', gstinDocs[x])
      }
    }

    // Bank Account Details
    businessData.append('bankAccountType', bankAccountType)
    businessData.append('accountHolderName', accountHolderName)
    businessData.append('accountNumber', accountNumber)
    businessData.append('ifscCode', ifscCode)
    businessData.append('bankAddress', bankAddress)
    for (var z = 0; z < cancelledChequeDocs.length; z++) {
      businessData.append('cancelledChequeDocs', cancelledChequeDocs[z])
    }

    Axios.post('/vendorbusiness', businessData)
      .then(function (response) {
        console.log('Response => ', response)
      })
      .catch(function (error) {
        console.log('Error => ', error)
      })
  }

  // Storing imageGalleryPic
  imageGalleryPic = evnt => {
    console.log('calling image Gallery ')
    let allImages = evnt.target.files;
    if(allImages.length > 5) {
      const msg = 'Only 4 images can be uploaded at a time'
      evnt.target.value = null
      console.log(msg)
      return false
    }
    for(var imgLen=0; imgLen<allImages.length; imgLen++) {
      let images = allImages[imgLen];
      this.state.imageGalleryNames.push(images);
    }
    console.log('Images => ', this.state.imageGalleryNames)
  }

  // cancelledChequePic
  cancelledCheque = vnt => {
    console.log('calling Handling Cancelled cheque')
    this.setState({
      cancelledChequeDocs: vnt.target.files
    })
  }

  // GST DocsHandler
  gstDocs = event => {
    console.log('calling GST Docs')
    this.setState({
      gstinDocs: event.target.files
    })
  }

  render () {
    const {
      firstName,
      lastName,
      dateOfBirth,
      contact,
      gender,
      emailId,
      permanentAddress,
      locality,
      pincode,
      panNumber,
      adharNumber,
      typeOfProgram,
      areaOfSpecialisation,
      college,
      yearOfCompletion,
      otherDegreeName,
      otherPgDegreeName,
      pgDegree,
      pgTypeOfProgram,
      pgCollege,
      pgYearOfCompletion,
      pgAreaOfSpecialisation,
      professionalCourseName,
      professionalYearOfCompletion,
      professionalCourseAffiliatedBoard,
      professionalCourseLicenseNumber,
      professionalCourseValidity,
      typeOfBusiness,
      tanStatus,
      tanNumber,
      stateOfSupply,
      taxCode,
      legalNameOfBusiness,
      businessPanNumber,
      registeredAddressFirm,
      bankAccountType,
      accountHolderName,
      accountNumber,
      ifscCode,
      bankAddress,
      gstRegistrationType,
      gstinNumber
    } = this.state
    return (
      <div className='container-fluid my-5' id='vendorRegistration'>
        <div className='row'>
          <div className='col-md-11 mx-auto'>
            <div className='row'>
              <div className='col-md-6 col-lg-3 mx-auto align-self-center'>
                <h2 className='text-info'>Online Registration form</h2>
                <img
                  src='./assets/img/vha.png'
                  className='img-fluid'
                  alt='img'
                />
                <ul
                  className='nav nav-pills nav-pills-info nav-pills-just-icons'
                  role='tablist'
                >
                  <li className='nav-item'>
                    <a
                      className='nav-link active'
                      data-toggle='tab'
                      href='#link20'
                      role='tab'
                    >
                      Basic Details
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      data-toggle='tab'
                      href='#link21'
                      role='tab'
                    >
                      Qualification Details
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      data-toggle='tab'
                      href='#link22'
                      role='tab'
                    >
                      Business Information
                    </a>
                  </li>
                </ul>
              </div>

              <div className='col-md-11 mx-auto col-lg-8 offset-lg-1 mx-auto form-div mt-5 mt-lg-0'>
                <div className='tab-content'>
                  <div className='tab-pane active' id='link20'>
                    <form onSubmit={this.submitHandler}>
                      <div className='row mt-4'>
                        <div className='col-md-11 col-lg-8  mx-auto'>
                          <div className='row'>
                            <div className='col-md-12'>
                              <div className='d-flex'>
                                <img
                                  src='./assets/img/Image-3.png'
                                  alt=''
                                  className='img-fluid'
                                />
                                <h2 className='text-info align-self-center font-xl'>
                                  Basic Details
                                </h2>
                              </div>
                            </div>
                          </div>
                          <h2 className='text-info font-xl borderBottom'>
                            Personal Details
                          </h2>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='firstname'>First Name*</label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='firstname'
                                  placeholder='First Name'
                                  name='firstName'
                                  value={firstName}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='lastname'>Last Name*</label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='lastname'
                                  placeholder='Last Name'
                                  name='lastName'
                                  value={lastName}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <label htmlFor='gender' className='d-block'>
                                Enter Gender*
                              </label>
                              <div className='form-check form-check-inline'>
                                <label
                                  className='form-check-label'
                                  htmlFor='male'
                                >
                                  Male
                                </label>
                                <input
                                  className='form-check-input ml-2'
                                  type='radio'
                                  name='gender'
                                  id='male'
                                  value='1'
                                  checked={gender === '1'}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>

                              <div className='form-check form-check-inline'>
                                <label
                                  className='form-check-label'
                                  htmlFor='female'
                                >
                                  Female
                                </label>
                                <input
                                  className='form-check-input ml-2'
                                  type='radio'
                                  name='gender'
                                  id='female'
                                  value='2'
                                  checked={gender === '2'}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='dob'>Date Of Birth*</label>
                                <input
                                  type='date'
                                  className='form-control'
                                  id='dob'
                                  name='dateOfBirth'
                                  placeholder='Date Of Birth'
                                  value={dateOfBirth}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='phonenumber'>
                                  Phone Number*
                                </label>
                                <input
                                  type='tel'
                                  className='form-control'
                                  id='phonenumber'
                                  placeholder='Phone Number'
                                  name='contact'
                                  value={contact}
                                  onChange={this.changeHandler}
                                  pattern='[6-9]{1}[0-9]{9}'
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='email'>Email id*</label>
                                <input
                                  type='email'
                                  className='form-control'
                                  id='email'
                                  placeholder='Email'
                                  name='emailId'
                                  value={emailId}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='col-md-12 col-lg-3 align-self-center'>
                          <div className='image-upload'>
                            <label htmlFor='file-input'>
                              <img
                                src='/assets/img/5.jpg'
                                alt=''
                                className='img-fluid img-circle'
                              />
                            </label>
                            <input
                              id='file-input'
                              type='file'
                              name='profilePic'
                              onChange={this.profilePicChangeHandler}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className='row'>
                        <div className='col-md-11 col-lg-8 offset-lg-1 mx-auto'>
                          <h2 className='text-info font-xl borderBottom'>
                            Contact & ID Proof Details
                          </h2>
                          <div className='row mb-4'>
                            <div className='col-md-6'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <div className='form-group'>
                                    <label htmlFor='name' className=''>
                                      Permanent address (Personal)
                                    </label>
                                    <textarea
                                      name='permanentAddress'
                                      value={permanentAddress}
                                      onChange={this.changeHandler}
                                      rows='5'
                                      placeholder='Please provide your permanent address'
                                      required
                                      minLength='10'
                                      maxLength='110'
                                      id='permanentAddress'
                                      className='form-control'
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <div className='form-group'>
                                    <label htmlFor='locality/Area/Sector'>
                                      locality/ Area/ Sector
                                    </label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='locality'
                                      name='locality'
                                      value={locality}
                                      onChange={this.changeHandler}
                                      placeholder='Enter Your locality'
                                      required
                                    />
                                  </div>
                                </div>

                                <div className='col-md-12'>
                                  <div className='form-group'>
                                    <label htmlFor='pinCode'>Pin Code</label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='pincode'
                                      name='pincode'
                                      value={pincode}
                                      onChange={this.changeHandler}
                                      placeholder='Pin Code'
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='pannumber'>PAN Number*</label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='pannumber'
                                  placeholder='ABCDE1234F'
                                  pattern='[A-Z]{5}[0-9]{4}[A-Z]{1}'
                                  minLength={10}
                                  maxLength={10}
                                  name='panNumber'
                                  value={panNumber}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='panattachment'>
                                  PAN Attachment*
                                </label>
                                <input
                                  type='file'
                                  className='form-control'
                                  id='panattachment'
                                  placeholder='KH-146, Gali No-27'
                                  name='panAttachment'
                                  onChange={this.panFileChangeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='adharnumber'>
                                  Aadhar Number*
                                </label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='adharnumber'
                                  placeholder='123456789011'
                                  minLength={12}
                                  maxLength={12}
                                  name='adharNumber'
                                  pattern='[0-9]{4}[0-9]{4}[0-9]{4}'
                                  value={adharNumber}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='adharattachment'>
                                  Aadhar Attachment*
                                </label>
                                <input
                                  type='file'
                                  className='form-control'
                                  id='adharattachment'
                                  placeholder='KH-146, Gali No-27'
                                  name='adharAttachment'
                                  onChange={this.adharFileChangeHandler}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='col-md-12 col-lg-3 align-self-end'>
                          <button
                            type='submit'
                            className='btn btn-primary btn-lg mx-auto'
                          >
                            Submit & Next
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className='tab-pane ' id='link21'>
                    <form onSubmit={this.ugDegreeHandler}>
                      <div className='row'>
                        <div className='col-lg-11 col-md-8 mx-auto'>
                          <div className='row'>
                            <div className='col-md-12'>
                              <div className='d-flex'>
                                <img
                                  src='./assets/img/Image-3.png'
                                  alt=''
                                  className='img-fluid'
                                />
                                <h2 className='text-info align-self-center font-xl'>
                                  Qualification Details
                                </h2>
                              </div>
                            </div>
                          </div>
                          <h2 className='text-info'>UG Degree*</h2>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='ugDegree'>UG Degree</label>
                                <select
                                  className='form-control'
                                  id='ugDegree'
                                  name='ugDegree'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value=''>Select</option>
                                  <option value='BSc (General)'>
                                    BSc (General)
                                  </option>
                                  <option value='BSc (Honors)'>
                                    BSc (Honors)
                                  </option>
                                  <option value='B.Pharma'>B.Pharma</option>
                                  <option value='BPT'>BPT</option>
                                  <option value='BOT'>BOT</option>
                                  <option value='BSc Nursing'>
                                    BSc Nursing
                                  </option>
                                  <option value='BNYS'>BNYS</option>
                                  <option value='MBBS'>MBBS</option>
                                  <option value='BUMS'>BUMS</option>
                                  <option value='BAMS'>BAMS</option>
                                  <option value='BHMS'>BHMS</option>
                                  <option value='BTech'>BTech</option>
                                  <option value='Other'>Other</option>
                                </select>
                              </div>
                            </div>

                            {this.state.ugDegree === 'Other' ? (
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='otherDegreeName'>
                                    Other UG Degree Name
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control'
                                    id='otherDegreeName'
                                    placeholder='Enter Other UG Degree'
                                    name='otherDegreeName'
                                    value={otherDegreeName}
                                    onChange={this.changeHandler}
                                    required
                                  />
                                </div>
                              </div>
                            ) : null}

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='programType'>
                                  Type of Program
                                </label>
                                <select
                                  className='form-control'
                                  id='programType'
                                  name='typeOfProgram'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value=''>Select</option>
                                  <option value='Full Time Regular'>
                                    Full Time Regular
                                  </option>
                                  <option value='Distance Learning'>
                                    Distance Learning
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='Specialisation'>
                                  Area of Specialisation
                                </label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='Specialisation'
                                  name='areaOfSpecialisation'
                                  placeholder='Provide area of specialisation'
                                  value={areaOfSpecialisation}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='CollegeUniversity'>
                                  College/University
                                </label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='CollegeUniversity'
                                  name='college'
                                  placeholder='Provide College/University'
                                  value={college}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='completionYear'>
                                  Completion Date
                                </label>
                                <input
                                  type='date'
                                  className='form-control'
                                  id='yearOfCompletion'
                                  onChange={this.changeHandler}
                                  value={yearOfCompletion}
                                  name='yearOfCompletion'
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <label htmlFor='ugDegreeDocs'>
                                UG Degree Attachment*
                              </label>
                              <input
                                type='file'
                                className='form-control'
                                id='ugDegreeDocs'
                                name='ugDegreeDocs'
                                onChange={this.ugDocs}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className='col-lg-11 col-md-8 mx-auto'>
                          <h2 className='text-info'>
                            Postgraduate Education Details
                          </h2>
                          <div
                            id='collapseOne'
                            className='collapse'
                            aria-labelledby='headingOne'
                            data-parent='#accordionExample'
                          >
                            <form onSubmit={this.pgDegreeHandler}>
                              <div className='row'>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='pgDegree'>PG Degree</label>
                                    <select
                                      className='form-control'
                                      id='pgDegree'
                                      name='pgDegree'
                                      onChange={this.changeHandler}
                                      required
                                    >
                                      <option value=''>Select</option>
                                      <option value='MSc'>MSc</option>
                                      <option value='MPhil'>MPhil</option>
                                      <option value='Doctorate'>
                                        Doctorate
                                      </option>
                                      <option value='MA'>MA</option>
                                      <option value='Other'>Other</option>
                                    </select>
                                  </div>
                                </div>

                                {this.state.pgDegree === 'Other' ? (
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label htmlFor='otherPgDegreeName'>
                                        Other PG Degree Name
                                      </label>
                                      <input
                                        type='text'
                                        className='form-control'
                                        id='otherPgDegreeName'
                                        placeholder='Enter Other UG Degree'
                                        name='otherPgDegreeName'
                                        onChange={this.changeHandler}
                                        value={otherPgDegreeName}
                                        required
                                      />
                                    </div>
                                  </div>
                                ) : null}

                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='pgTypeOfProgram'>
                                      Type of Program
                                    </label>
                                    <select
                                      className='form-control'
                                      id='pgTypeOfProgram'
                                      name='pgTypeOfProgram'
                                      onChange={this.changeHandler}
                                      required
                                    >
                                      <option value=''>Select</option>
                                      <option value='Full Time Regular'>
                                        Full Time Regular
                                      </option>
                                      <option value='Distance Learning'>
                                        Distance Learning
                                      </option>
                                    </select>
                                  </div>
                                </div>

                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='pgAreaOfSpecialisation'>
                                      Area of Specialisation
                                    </label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='pgAreaOfSpecialisation'
                                      name='pgAreaOfSpecialisation'
                                      value={pgAreaOfSpecialisation}
                                      onChange={this.changeHandler}
                                      placeholder='Provide area of specialisation'
                                      required
                                    />
                                  </div>
                                </div>

                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='pgCollege'>
                                      College/University
                                    </label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='pgCollege'
                                      name='pgCollege'
                                      onChange={this.changeHandler}
                                      value={pgCollege}
                                      placeholder='Provide College/University'
                                      required
                                    />
                                  </div>
                                </div>

                                <div className='col-md-6'>
                                  <label htmlFor='pgYearOfCompletion'>
                                    Year of Completion
                                  </label>
                                  <input
                                    id='pgYearOfCompletion'
                                    name='pgYearOfCompletion'
                                    placeholder='date'
                                    type='date'
                                    className='form-control'
                                    onChange={this.changeHandler}
                                    value={pgYearOfCompletion}
                                    required
                                  />
                                </div>

                                <div className='col-md-6'>
                                  <label htmlFor='pgFile'>
                                    PG Degree Attachment*
                                  </label>
                                  <input
                                    type='file'
                                    name='pgDegreeDocs'
                                    className='form-control'
                                    id='pgDegreeDocs'
                                    onChange={this.pgDocs}
                                    required
                                  />
                                </div>
                              </div>
                              <div className='col-md-12 col-lg-12 text-center'>
                                <button
                                  type='submit'
                                  className='btn btn-primary btn-lg mt-4 mx-auto '
                                >
                                  Submit
                                </button>
                              </div>
                            </form>
                          </div>
                          {this.state.pgDegreeData.length > 0 ? (
                            <div className='row'>
                              <div className='col-md-12'>
                                <div className='card'>
                                  <table className='table'>
                                    <thead>
                                      <tr className='text-danger'>
                                        <th>Sl No.</th>
                                        <th>PG Degree</th>
                                        <th>Type of Program</th>
                                        <th>Area of Specialisation</th>
                                        <th>College/University</th>
                                        <th>Year of Completion</th>
                                        <th>Options</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.pgDegreeData.map(
                                        (data, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>{data.pgDegree}</td>
                                              <td>{data.pgTypeOfProgram}</td>
                                              <td>
                                                {data.pgAreaOfSpecialisation}
                                              </td>
                                              <td>{data.pgCollege}</td>
                                              <td>{data.pgYearOfCompletion}</td>
                                              <td>
                                                <Button
                                                  color='link'
                                                  size='sm'
                                                  onClick={() =>
                                                    this.handlePgDegreeDelete(
                                                      index
                                                    )
                                                  }
                                                >
                                                  <i
                                                    className='fa fa-trash'
                                                    style={{
                                                      color: 'red',
                                                      fontSize: '20px'
                                                    }}
                                                    aria-hidden='true'
                                                  ></i>
                                                </Button>
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className='accordion' id='accordionExample'>
                            <div id='headingOne'>
                              <h2 className='mb-0'>
                                <button
                                  className='btn btn-link btn-block text-left'
                                  type='button'
                                  data-toggle='collapse'
                                  data-target='#collapseOne'
                                  aria-expanded='true'
                                  aria-controls='collapseOne'
                                >
                                  Add PG Course
                                </button>
                              </h2>
                            </div>
                          </div>
                        </div>

                        <div className='col-lg-11 col-md-8 mx-auto'>
                          <h2 className='text-info'>Professional Course</h2>
                          <div
                            id='collapseTwo'
                            className='collapse'
                            aria-labelledby='headingtwo'
                            data-parent='#accordionExample'
                          >
                            <form onSubmit={this.professionalCourseHandler}>
                              <div className='row'>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='professionalCourseName'>
                                      Course/Program Name
                                    </label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='professionalCourseName'
                                      name='professionalCourseName'
                                      placeholder='Provide Course /Program'
                                      value={professionalCourseName}
                                      onChange={this.changeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <label htmlFor='professionalYearOfCompletion'>
                                    Year of Completion
                                  </label>
                                  <input
                                    name='professionalYearOfCompletion'
                                    placeholder='date'
                                    type='date'
                                    className='form-control'
                                    id='professionalYearOfCompletion'
                                    onChange={this.changeHandler}
                                    required
                                  />
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='professionalCourseAffiliatedBoard'>
                                      Write Affiliated Center/ Board/ Society/
                                      Hospital Name & City
                                    </label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='professionalCourseAffiliatedBoard'
                                      name='professionalCourseAffiliatedBoard'
                                      placeholder='Provide Affiliated Center/ Board/ Society/ Hospital Name & City'
                                      value={professionalCourseAffiliatedBoard}
                                      onChange={this.changeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='professionalCourseLicenseNumber'>
                                      Certificate/ Certificate/ License Number
                                    </label>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='professionalCourseLicenseNumber'
                                      name='professionalCourseLicenseNumber'
                                      placeholder='Provide Certificate/ License Number'
                                      value={professionalCourseLicenseNumber}
                                      onChange={this.changeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='professionalCourseValidity'>
                                      Validity of Course Certificate
                                    </label>
                                    <select
                                      className='form-control'
                                      id='professionalCourseValidity'
                                      name='professionalCourseValidity'
                                      onChange={this.changeHandler}
                                      required
                                    >
                                      <option value=''>Select</option>

                                      <option value='limited time'>
                                        Limited Time
                                      </option>
                                      <option value='life time'>
                                        Life Time
                                      </option>
                                      <option value='na'>NA</option>
                                    </select>
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <label htmlFor='professionalCourseDocs'>
                                      Upload Professional Certificate*
                                    </label>

                                    <input
                                      type='file'
                                      className='form-control'
                                      id='professionalCourseDocs'
                                      name='professionalCourseDocs'
                                      required
                                    />
                                  </div>
                                </div>
                                <div className='col-md-12 col-lg-12 text-center'>
                                  <button
                                    type='submit'
                                    className='btn btn-primary btn-lg mb-4 mx-auto '
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                          {this.state.professionalCourse.length > 0 ? (
                            <div className='row'>
                              <div className='col-md-12'>
                                <div className='card'>
                                  <table className='table'>
                                    <thead>
                                      <tr className='text-danger'>
                                        <th>Sl No.</th>
                                        <th>Course Name</th>
                                        <th>Affiliated Board/Society</th>
                                        <th>Year Of Completion</th>
                                        <th>Certificatie/License Number</th>
                                        <th>Validity</th>
                                        <th>Options</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.professionalCourse.map(
                                        (data, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>
                                                {data.professionalCourseName}
                                              </td>
                                              <td>
                                                {
                                                  data.professionalCourseAffiliatedBoard
                                                }
                                              </td>
                                              <td>
                                                {
                                                  data.professionalYearOfCompletion
                                                }
                                              </td>
                                              <td>
                                                {
                                                  data.professionalCourseLicenseNumber
                                                }
                                              </td>
                                              <td>
                                                {
                                                  data.professionalCourseValidity
                                                }
                                              </td>
                                              <td>
                                                <Button
                                                  color='link'
                                                  size='sm'
                                                  onClick={() =>
                                                    this.handleProfessionalCourseDeletion(
                                                      index
                                                    )
                                                  }
                                                >
                                                  <i
                                                    className='fa fa-trash'
                                                    style={{
                                                      color: 'red',
                                                      fontSize: '20px'
                                                    }}
                                                    aria-hidden='true'
                                                  ></i>
                                                </Button>
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className='accordion' id='accordionExample2'>
                            <div id='headingTwo'>
                              <h2 className='mb-0'>
                                <button
                                  className='btn btn-link btn-block text-left'
                                  type='button'
                                  data-toggle='collapse'
                                  data-target='#collapseTwo'
                                  aria-expanded='true'
                                  aria-controls='collapseTwo'
                                >
                                  Add Professional Course
                                </button>
                              </h2>
                            </div>
                          </div>
                        </div>

                        <div className='col-md-12 col-lg-12 text-center'>
                          <button
                            type='submit'
                            className='btn btn-primary btn-lg mb-4 mx-auto '
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className='tab-pane ' id='link22'>
                    <form onSubmit={this.businessInformationDetails}>
                      <div className='row'>
                        <div className='col-lg-11 col-md-8 mx-auto'>
                          <div className='row'>
                            <div className='col-md-12'>
                              <div className='d-flex'>
                                <img
                                  src='./assets/img/Image-3.png'
                                  alt=''
                                  className='img-fluid'
                                />
                                <h2 className='text-info align-self-center font-xl'>
                                  Business Details
                                </h2>
                              </div>
                            </div>
                          </div>
                          <h2 className='text-info font-xl'>Tax Details</h2>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='typeOfBusiness'>
                                  Type of Business
                                </label>
                                <select
                                  className='form-control'
                                  id='typeOfBusiness'
                                  name='typeOfBusiness'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value='' disable>
                                    Select
                                  </option>
                                  <option value='1'>
                                    Individual Freelancer
                                  </option>
                                  <option value='2'>Proprieteriship</option>
                                  <option value='3'>Partnership</option>
                                  <option value='4'>Trust/Society</option>
                                  <option value='5'>Private Ltd</option>
                                </select>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='gstStatus'>GST Status</label>
                                <select
                                  className='form-control'
                                  id='gstStatus'
                                  name='gstStatus'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value='' disable>
                                    Select
                                  </option>
                                  <option value='1'>I have GST Number</option>
                                  <option value='0'>
                                    I sell in GST Exempted Category
                                  </option>
                                  <option value='0'>
                                    I have never registered for GST
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='tanStatus'>
                                  TDS-TAN Status
                                </label>
                                <select
                                  className='form-control'
                                  id='tanStatus'
                                  name='tanStatus'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value='' disable>
                                    Select
                                  </option>
                                  <option value='0'>
                                    I am not liable to deduct TDS
                                  </option>
                                  <option value='1'>I have TAN for TDS</option>
                                </select>
                              </div>
                            </div>
                            {this.state.tanStatus === '1' ? (
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='tanNumber'>TAN Number</label>
                                  <input
                                    type='text'
                                    name='tanNumber'
                                    id='tanNumber'
                                    className='form-control'
                                    placeholder='Enter Your TAN Number'
                                    onChange={this.changeHandler}
                                    value={tanNumber}
                                    required
                                  />
                                </div>
                              </div>
                            ) : null}
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='stateOfSupply'>
                                  State of Supply
                                </label>

                                <select
                                  name='stateOfSupply'
                                  onChange={this.changeHandler}
                                  required
                                  id='stateOfSupply'
                                  className=' form-control'
                                >
                                  <option value='' disable=''>
                                    Select
                                  </option>
                                  <option value='Andhra Pradesh'>
                                    Andhra Pradesh
                                  </option>
                                  <option value='Andaman and Nicobar Islands'>
                                    Andaman and Nicobar Islands
                                  </option>
                                  <option value='Arunachal Pradesh'>
                                    Arunachal Pradesh
                                  </option>
                                  <option value='Assam'>Assam</option>
                                  <option value='Bihar'>Bihar</option>
                                  <option value='Chandigarh'>Chandigarh</option>
                                  <option value='Chhattisgarh'>
                                    Chhattisgarh
                                  </option>
                                  <option value='Dadar and Nagar Haveli'>
                                    Dadar and Nagar Haveli
                                  </option>
                                  <option value='Daman and Diu'>
                                    Daman and Diu
                                  </option>
                                  <option value='Delhi'>Delhi</option>
                                  <option value='Lakshadweep'>
                                    Lakshadweep
                                  </option>
                                  <option value='Puducherry'>Puducherry</option>
                                  <option value='Goa'>Goa</option>
                                  <option value='Gujarat'>Gujarat</option>
                                  <option value='Haryana'>Haryana</option>
                                  <option value='Himachal Pradesh'>
                                    Himachal Pradesh
                                  </option>
                                  <option value='Jammu and Kashmir'>
                                    Jammu and Kashmir
                                  </option>
                                  <option value='Jharkhand'>Jharkhand</option>
                                  <option value='Karnataka'>Karnataka</option>
                                  <option value='Kerala'>Kerala</option>
                                  <option value='Madhya Pradesh'>
                                    Madhya Pradesh
                                  </option>
                                  <option value='Maharashtra'>
                                    Maharashtra
                                  </option>
                                  <option value='Manipur'>Manipur</option>
                                  <option value='Meghalaya'>Meghalaya</option>
                                  <option value='Mizoram'>Mizoram</option>
                                  <option value='Nagaland'>Nagaland</option>
                                  <option value='Odisha'>Odisha</option>
                                  <option value='Punjab'>Punjab</option>
                                  <option value='Rajasthan'>Rajasthan</option>
                                  <option value='Sikkim'>Sikkim</option>
                                  <option value='Tamil Nadu'>Tamil Nadu</option>
                                  <option value='Telangana'>Telangana</option>
                                  <option value='Tripura'>Tripura</option>
                                  <option value='Uttar Pradesh'>
                                    Uttar Pradesh
                                  </option>
                                  <option value='Uttarakhand'>
                                    Uttarakhand
                                  </option>
                                  <option value='West Bengal'>
                                    West Bengal
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='taxCode'>TDS-TAN Status</label>
                                <select
                                  className='form-control'
                                  id='taxCode'
                                  name='taxCode'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value=''>Select</option>
                                  <option value='0'>GST_0</option>
                                  <option value='1'>GST_12</option>
                                  <option value='2'>GST_18</option>
                                  <option value='3'>GST_28</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {this.state.typeOfBusiness !== '1' ? (
                        <div className='row'>
                          <div className='col-lg-11 col-md-8 mx-auto'>
                            <h2 className='text-info font-xl'>
                              Business Details
                            </h2>
                            <div className='row'>
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='legalNameOfBusiness'>
                                    Legal Name of Business/Firm
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control'
                                    id='legalNameOfBusiness'
                                    name='legalNameOfBusiness'
                                    onChange={this.changeHandler}
                                    value={legalNameOfBusiness}
                                    placeholder='Legal Name of Business/Firm'
                                    required
                                  />
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='businessPanNumber'>
                                    Business PAN Number
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control'
                                    id='businessPanNumber'
                                    name='businessPanNumber'
                                    onChange={this.changeHandler}
                                    value={businessPanNumber}
                                    placeholder='Business PAN Number'
                                    required
                                  />
                                </div>
                              </div>

                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='registeredAddressFirm'>
                                    Registered Address of Firm/Business
                                    (Complete)
                                  </label>

                                  <textarea
                                    name='registeredAddressFirm'
                                    rows='3'
                                    placeholder='Registered Address of Firm/Business'
                                    required
                                    minLength='10'
                                    maxLength='110'
                                    id='registeredAddressFirm'
                                    className=' form-control'
                                    onChange={this.changeHandler}
                                    value={registeredAddressFirm}
                                  ></textarea>
                                </div>
                              </div>

                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='imageGallery'>
                                    Image Gallery
                                  </label>
                                  <input
                                    type='file'
                                    className='form-control'
                                    id='imageGallery'
                                    name='imageGallery'
                                    onChange={this.imageGalleryPic}
                                    multiple
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {this.state.gstStatus === '1' ? (
                        <div className='row'>
                          <div className='col-lg-11 col-md-8 mx-auto'>
                            <h2 className='text-info font-xl'>GSTIN Details</h2>
                            <div className='row'>
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='gstRegistrationType'>
                                    GST Registration Type
                                  </label>
                                  <select
                                    className='form-control'
                                    id='gstRegistrationType'
                                    name='gstRegistrationType'
                                    onChange={this.changeHandler}
                                    required
                                  >
                                    <option value='0' disable>
                                      Select
                                    </option>
                                    <option value='1'>Regular</option>
                                    <option value='2'>Composition</option>
                                  </select>
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='gstinNumber'>
                                    GSTIN Number
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control'
                                    name='gstinNumber'
                                    id='gstinNumber'
                                    value={gstinNumber}
                                    placeholder='Enter your GSTIN Number'
                                    onChange={this.changeHandler}
                                    required
                                  />
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <div className='form-group'>
                                  <label htmlFor='gstinDocs'>
                                    Upload GSTIN Certificate
                                  </label>
                                  <input
                                    type='file'
                                    id='file-input'
                                    name='gstinDocs'
                                    className='form-control'
                                    onChange={this.gstDocs}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className='row'>
                        <div className='col-lg-11 col-md-8 mx-auto'>
                          <h2 className='text-info font-xl'>
                            Bank Account Details
                          </h2>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='bankAccountType'>
                                  Bank A/c Type
                                </label>
                                <select
                                  className='form-control'
                                  id='bankAccountType'
                                  name='bankAccountType'
                                  onChange={this.changeHandler}
                                  required
                                >
                                  <option value='' disable=''>
                                    Select Bank A/C Type
                                  </option>
                                  <option value='1'>Saving A/C</option>
                                  <option value='2'>Current A/C</option>
                                </select>
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='accountHolderName'>
                                  Account holder name
                                </label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='accountHolderName'
                                  name='accountHolderName'
                                  placeholder='Provide Account Holder Name'
                                  onChange={this.changeHandler}
                                  value={accountHolderName}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='accountNumber'>
                                  Account Number
                                </label>
                                <input
                                  type='number'
                                  className='form-control'
                                  id='accountNumber'
                                  name='accountNumber'
                                  placeholder='Provide Account Number'
                                  onChange={this.changeHandler}
                                  value={accountNumber}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='ifscCode'>IFSC code</label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='ifscCode'
                                  name='ifscCode'
                                  placeholder='Provide IFSC Code'
                                  onChange={this.changeHandler}
                                  value={ifscCode}
                                  required
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='bankAddress'>
                                  Bank Address(Complete)
                                </label>
                                <textarea
                                  name='bankAddress'
                                  row='3'
                                  placeholder='Provide Bank Address'
                                  required
                                  minLength='10'
                                  maxLength='110'
                                  id='bankAddress'
                                  className='form-control'
                                  onChange={this.changeHandler}
                                  value={bankAddress}
                                ></textarea>
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label htmlFor='uploadcancellCheque'>
                                  Upload Cancelled Cheque
                                </label>
                                <input
                                  type='file'
                                  className='form-control'
                                  id='uploadcancellCheque'
                                  name='uploadcancellCheque'
                                  onChange={this.cancelledCheque}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='row'>
                        <div className='col-md-12 text-center'>
                          <button
                            type='submit'
                            className='btn btn-primary btn-lg my-4'
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MyComponent
